import {createContext} from "react";

export const NotificationContext = createContext({
    selectedNavigationToggle: 0,
    setSelectedNavigationToggle: () => {},
    reloadNotifications: () => {},
    notificationsCount: 0,
    notificationsViewedCount: 0,
    notificationsNotViewedCount: 0,
    notificationsToDisplay: []
})
